






























































import { Component, Emit, Vue, Prop, Watch } from "vue-property-decorator";
import { values, cloneDeep, filter } from "lodash";
import VJsf from "@koumoul/vjsf/lib/VJsf.js";
import "@koumoul/vjsf/lib/VJsf.css";
import "@koumoul/vjsf/lib/deps/third-party.js";

import {
  ContextPropertyType,
  Gipt,
  GiptContextProperty,
  LogicalOperator
} from "@/interfaces/meeting/details";
import {
  defaultFormat,
  formatCurrencyText,
  convertNumeral
} from "@/utils/currency";
import {
  lacs,
  PackageListResponse
} from "@/interfaces/packages/sales_packages";

@Component({
  components: {
    VJsf
  },
  filters: {
    formatCurrencyText,
    convertNumeral
  }
})
export default class GiptForm extends Vue {
  @Prop({ type: Object, default: () => ({}) })
  giptSchema!: object;

  @Prop({ type: Array, default: () => [] })
  contextProperties!: GiptContextProperty[];

  @Prop({ type: Boolean, default: false })
  isEditMode!: boolean;

  @Prop({ type: Object, default: () => ({}) })
  defaultGipt!: Gipt;

  @Prop({ type: Array, default: () => [] })
  giptPackages!: PackageListResponse[];

  @Prop({ required: true })
  currency!: string;

  @Prop({ required: true })
  numberFormat!: string;

  isValid = false;
  model: Gipt = {};
  isClearingForm = false;

  mounted() {
    if (this.defaultGipt !== null) {
      this.model = cloneDeep(this.defaultGipt);
    }
  }

  @Watch("defaultGipt", { deep: true })
  onDefaultGiptChange(newDefaultGipt: Gipt, _: Gipt) {
    if (newDefaultGipt !== null) {
      this.model = cloneDeep(newDefaultGipt);
    }
  }

  // Check if all array fields initialized in model
  get isModelInitialized() {
    if (
      this.model === {} ||
      this.giptSchema === null ||
      !("properties" in this.giptSchema)
    ) {
      return false;
    }
    // Get model properties length
    const modelPropertiesLength = values(this.model).length;
    // Get schema array properties length
    const schemaProperties = (this.giptSchema as any)["properties"];
    const schemaArrayProperties = filter(
      schemaProperties,
      property => property.type === "array"
    );
    const schemaArrayPropertiesLength = schemaArrayProperties.length;
    return modelPropertiesLength >= schemaArrayPropertiesLength;
  }

  @Watch("model", { deep: true })
  onModelChange(newModel: Gipt, _: Gipt) {
    if (this.isModelInitialized && this.isEditMode) {
      if (this.isClearingForm) {
        this.isClearingForm = false;
        this.resetFormAndPackages(newModel);
      } else {
        this.updateModel(newModel);
      }
    }
  }

  @Emit()
  addToCart(packageId: number) {
    return packageId;
  }

  @Emit()
  updateModel(newModel: Gipt) {
    return newModel;
  }

  @Emit()
  resetFormAndPackages(newModel: Gipt) {
    return newModel;
  }

  get formClass() {
    return {
      "form-no-interaction": !this.isEditMode
    };
  }

  // Options to pass into the VJSF
  get options() {
    const context: { [id: string]: boolean } = {};
    // Convert context properties to context
    for (const contextProperty of this.contextProperties) {
      const contextPropertyName: string = contextProperty.contextPropertyName;
      const contextPropertyType: ContextPropertyType = contextProperty.type;
      const value1: string = contextProperty.value1 ?? "";
      const value2: string = contextProperty.value2 ?? "";
      let isEnabled = false;
      if (contextPropertyType === ContextPropertyType.EQUAL) {
        const modelProperty = this.model[value1];
        if (Array.isArray(modelProperty)) {
          isEnabled = modelProperty.includes(value2);
        } else {
          isEnabled = modelProperty === value2;
        }
      } else if (contextPropertyType === ContextPropertyType.HAS_VALUE) {
        const modelProperty = this.model[value1];
        if (Array.isArray(modelProperty)) {
          isEnabled = modelProperty !== null && modelProperty.length > 0;
        } else {
          isEnabled =
            modelProperty !== undefined &&
            modelProperty !== null &&
            modelProperty !== "";
        }
      } else if (
        contextPropertyType === ContextPropertyType.LOGICAL_OPERATORS
      ) {
        const contextPropertyArray = value1.split(",");
        for (let i = 0; i < contextPropertyArray.length; i += 2) {
          const contextProperty = context[contextPropertyArray[i]];
          if (i === 0) {
            isEnabled = contextProperty;
          } else {
            const logicalOperator = contextPropertyArray[i - 1];
            if (logicalOperator === LogicalOperator.AND) {
              isEnabled = isEnabled && contextProperty;
            } else if (logicalOperator === LogicalOperator.OR) {
              isEnabled = isEnabled || contextProperty;
            }
          }
        }
      }
      context[contextPropertyName] = isEnabled;
    }
    return {
      context: context
    };
  }

  get isLacsFormat() {
    return lacs === this.numberFormat;
  }

  get currencyText() {
    // If is default format, return nothing
    if (defaultFormat === this.numberFormat) {
      return "";
    }
    return this.numberFormat;
  }

  clearForm() {
    this.model = {};
    this.isClearingForm = true;
  }
}
